import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { rem } from 'polished';

const StyledThumbnail = styled.div`
  display: flex;
  flex: 0 1 auto;
  position: relative;
  z-index: 1;
  border-radius: ${rem(`8px`)};
  overflow: hidden;

  .thumbnail__image-wrapper {
    display: flex;
    flex-wrap: wrap;
    flex: 1 0 auto;
    color: ${({ theme }) => theme.colors.white_1};
    border-radius: ${rem(`8px`)};
  }
  .thumbnail__image-container {
    display: flex;
    flex: 1 0 auto;
    flex-wrap: wrap;
    padding: 1px;
    margin: 1px;
    border-radius: ${rem(`8px`)};
    position: relative;
    box-sizing: border-box;
    background-clip: padding-box;
    border: solid 1px transparent;
    background: ${({ theme }) => `linear-gradient(
      265deg,
      ${theme.colors.blue_1},
      ${theme.colors.blue_1_90}
    )`};
    ::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: inherit;
      margin: -2px;
      z-index: -1;
      background: ${({ theme }) => `linear-gradient(
          295deg,
          ${theme.colors.blue_1_30},
          ${theme.colors.blue_1_65},
          ${theme.colors.pink_2}
        )`};
    }
  }
  .thumbnail__image {
    border-radius: ${rem(`8px`)};
    flex: 1 0 auto;
    position: relative;
    z-index: 1010;
  }
`;

export interface IThumbnail {
  imageSrc: any;
  alt?: string;
  className?: string;
}

export const Thumbnail = ({ imageSrc, alt, className }: IThumbnail) => {
  return (
    <StyledThumbnail className={`${className} thumbnail`}>
      <div className="thumbnail__image-wrapper">
        <div className="thumbnail__image-container">
          <GatsbyImage
            image={imageSrc}
            alt={alt}
            className="thumbnail__image"
          />
        </div>
      </div>
    </StyledThumbnail>
  );
};
